module.exports = __webpack_public_path__ + "img/close-help-button.6d90e3a2.svg";